export default __webpack_public_path__ + "static/media/pc_banner.ac21d22a.jpg";